// extracted by mini-css-extract-plugin
export default {"job":"qKtYod30","author":"GGTnJXay","body":"xMZsJb7m"};